import styles from "./FormField.module.css";
import { FieldError } from "./FieldError";

interface TextAreaFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
  maxLength?: number;
}

export function TextAreaField({
  id,
  label,
  value,
  onChange,
  error,
  required,
  helperText,
  placeholder,
  maxLength,
}: TextAreaFieldProps) {
  const errorId = `${id}-error`;
  const helperId = `${id}-helper`;
  const countId = `${id}-count`;
  const describedBy =
    [helperText ? helperId : null, error ? errorId : null, maxLength ? countId : null]
      .filter(Boolean)
      .join(" ") || undefined;

  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label} {!required && <span className={styles.optional}>(optioneel)</span>}
      </label>
      {helperText && (
        <span id={helperId} className={styles.helperText}>
          {helperText}
        </span>
      )}
      <textarea
        id={id}
        className={[styles.textarea, error ? styles.invalid : ""].filter(Boolean).join(" ")}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={Boolean(error) || undefined}
        aria-describedby={describedBy}
        aria-required={required || undefined}
      />
      {maxLength && (
        <span id={countId} className={styles.charCount} aria-live="polite">
          {value.length} / {maxLength} tekens
        </span>
      )}
      <FieldError id={errorId} message={error} />
    </div>
  );
}
